import { Button$PressEvent } from "sap/m/Button";
import BaseController from "../controller/BaseController";
import ObjectPageSubSection from "sap/uxap/ObjectPageSubSection";
import { ObjectPageSubSectionMode } from "sap/uxap/library";

/**
 * @namespace com.unitrade.crm.blocks
 */
export default class BelegKopfBlock extends BaseController {
  handleExpandCollapsePress = (oEvent: Button$PressEvent) => {
    const parentBlock = (this as any).oParentBlock as ObjectPageSubSection;
    const sNewMode = parentBlock.getMode() === ObjectPageSubSectionMode.Collapsed ? ObjectPageSubSectionMode.Expanded : ObjectPageSubSectionMode.Collapsed;
    parentBlock.setMode(sNewMode);
  };
}
